import { ISelctedSeat } from "@/redux/rent/types";
import { IGruntItem } from "@/redux/profile/grunt/types";
import { validateAndPrepareBasketItems } from "./validateAndPrepareBasketItems";

export function prepareCancelReserveForReOrder(
  gruntItem: IGruntItem
): Array<{
  courtId: string;
  startTime: string;
  finishTime: string;
}> {
  try {
    const date = gruntItem.date;
    const time = gruntItem.time;
    
    const [hours, minutes] = time.split(':').map(Number);
    const startDate = new Date(date);
    startDate.setHours(hours, minutes, 0, 0);
    
    if (isNaN(startDate.getTime())) {
      console.warn(`Invalid date/time for gruntItem:`, { date, time });
      return [];
    }

    const finishDate = new Date(startDate);
    finishDate.setMinutes(finishDate.getMinutes() + 59);
    finishDate.setSeconds(59);

    const startTime = startDate.toISOString();
    const finishTime = finishDate.toISOString();

    const courtId = (gruntItem.court as any)?.courtId || gruntItem.court_id?.toString() || '';

    if (!courtId) {
      console.warn(`Missing courtId for gruntItem:`, gruntItem);
      return [];
    }

    return [{
      courtId,
      startTime,
      finishTime,
    }];
  } catch (error) {
    console.error(`Error preparing cancel reserve for reorder:`, error);
    return [];
  }
}

export function isReOrderOperation(gruntId: number | null): boolean {
  return gruntId !== null && gruntId !== undefined;
}
